'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

require('flickity-imagesloaded');

var _flickity = require('flickity');

var _flickity2 = _interopRequireDefault(_flickity);

var _module = require('./mixins/module');

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductRelatedCarousel = function (_Module) {
  (0, _inherits3.default)(ProductRelatedCarousel, _Module);

  function ProductRelatedCarousel(el) {
    (0, _classCallCheck3.default)(this, ProductRelatedCarousel);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ProductRelatedCarousel.__proto__ || (0, _getPrototypeOf2.default)(ProductRelatedCarousel)).call(this, el));

    _this.els = {
      el: el,
      carousel: _this.getContextElement('.' + _this.className + '_Carousel'),
      controls: _this.getContextElement('.' + _this.className + '_Controls'),
      previous: _this.getContextElement('.' + _this.className + '_Previous'),
      next: _this.getContextElement('.' + _this.className + '_Next')
    };

    _this.flkty = new _flickity2.default(_this.els.carousel, {
      prevNextButtons: false,
      cellAlign: 'left',
      imagesLoaded: true,
      wrapAround: true,
      pageDots: false
    });

    // Setup custom buttons
    _this.els.previous.addEventListener('click', function () {
      _this.flkty.previous();
    });

    _this.els.next.addEventListener('click', function () {
      _this.flkty.next();
    });

    window.productRelatedCarousel = _this;
    return _this;
  }

  return ProductRelatedCarousel;
}(_module2.default);

exports.default = ProductRelatedCarousel;